import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminName', data.nombre);
        localStorage.setItem('adminRole', data.role);
        localStorage.setItem('adminEmail', data.email);
        navigate('/admin/dashboard');
      } else {
        setError(data.error || 'Error de autenticación');
      }
    } catch (err) {
      setError('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo__text">EMILIO MORO</div>
          <div className="login-logo__subtext">BODEGAS</div>
        </div>
        <h1 className="login-title">Panel de Administración</h1>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}

          <div className="input-group">
            <label className="label">Email</label>
            <input
              type="text"
              className="input input--lg"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="usuario@emiliomoro.com"
              required
            />
          </div>

          <div className="input-group">
            <label className="label">Contraseña</label>
            <input
              type="password"
              className="input input--lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="login-submit"
            style={{ opacity: loading ? 0.7 : 1 }}
            disabled={loading}
          >
            {loading ? 'Accediendo...' : 'Acceder'}
          </button>
        </form>

        <div className="login-back">
          <span className="link" onClick={() => navigate('/')}>
            Volver a la encuesta
          </span>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
